import React from 'react';
import { colourString, skillScoreRounding } from '../../../library/helpers';
import styles from './skill-percentage.module.css';
import classNames from 'classnames';
import { Chip } from '../../chips';
import { generateLabel } from './skill-percentage.helpers';
function Bars(_a) {
    var score = _a.score, barColour = _a.barColour;
    var level = Math.ceil(((score !== null && score !== void 0 ? score : 1) / 100) * 5) + 1;
    var bars = [
        [3, 0.174805, 12.9199],
        [6, 4.28711, 9.91992],
        [9, 8.40234, 6.91992],
        [12, 12.5137, 3.91992],
        [15, 16.6279, 0.919922],
    ];
    return (React.createElement("svg", { fill: "none", viewBox: "0 0 20 16", height: 15 }, bars.map(function (_a, index) {
        var bar = _a[0], x = _a[1], y = _a[2];
        var active = level > index + 1;
        return React.createElement("rect", { key: bar, width: "2.99759", height: bar, x: x, y: y, fill: colourString(active ? barColour : 'default_2'), rx: "1" });
    })));
}
export function SkillPercentage(_a) {
    var percentage = _a.percentage, notAssessed = _a.notAssessed, title = _a.title, _b = _a.titleColour, titleColour = _b === void 0 ? 'text_1' : _b, includeLabel = _a.includeLabel, _c = _a.labelColour, labelColour = _c === void 0 ? 'text' : _c, _d = _a.barColour, barColour = _d === void 0 ? 'baby-blue' : _d;
    return (React.createElement("div", { className: classNames("KPLR_SkillPercentage", styles.container) },
        !!title && (React.createElement("h6", { className: "caption2", style: { color: colourString(titleColour) } }, title)),
        notAssessed ? (React.createElement("div", { className: styles.chip },
            React.createElement(Chip, { label: "Not assessed", variant: "tiny" }))) : (React.createElement("div", { className: styles.content },
            !!includeLabel && (React.createElement("h5", { className: "caption1", style: { color: colourString(labelColour), textWrap: 'nowrap' } }, generateLabel(percentage))),
            React.createElement("div", { className: styles.percentage },
                React.createElement(Bars, { barColour: barColour, score: percentage }),
                React.createElement("span", { className: "body1", style: { color: colourString(barColour) } },
                    skillScoreRounding(percentage !== null && percentage !== void 0 ? percentage : 0),
                    "%"))))));
}
export default SkillPercentage;
